import React, {useMemo} from 'react';
import {Button} from '~/components/Button';
import {EditorInput} from '~/components/Controls/Editor';
import {IModalComponent} from '~/components/Modal';
import {Title} from '~/components/Title';
import {formatJsonValue} from '~/lib/json';

interface IJsonViewerModalProps {
    title?: string;
    value: unknown;
}

export const JsonViewerModal: IModalComponent<IJsonViewerModalProps> = props => {
    const formatted = useMemo(() => {
        return formatJsonValue(props.value);
    }, [props.value]);

    return (
        <div style={{minWidth: 720}}>
            <Title>{props.title || 'JSON'}</Title>
            <EditorInput
                id="json-viewer-modal"
                mode="json"
                minLines={16}
                maxLines={60}
                disabled
                canFullScreen
                canCopy
                value={formatted}
            />
            <div style={{marginTop: 16, textAlign: 'right'}}>
                <Button onClick={props.close}>Close</Button>
            </div>
        </div>
    );
};
